import { render, staticRenderFns } from "./ViewProduct.vue?vue&type=template&id=52e4a018"
import script from "./ViewProduct.vue?vue&type=script&lang=js"
export * from "./ViewProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports